// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"218":"component---src-pages-404-tsx","691":"component---src-pages-index-tsx","806":"component---src-pages-privacy-policy-tsx"}[chunkId] + "-" + {"218":"5c2093410e0b3c537ab6","691":"d1e272916470dafac77d","806":"9322fdf06e2fcf81a3c1"}[chunkId] + ".js";
};